import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { EstabelecimentoResponse } from '../models/estabelecimento-response.model';

@Injectable({
  providedIn: 'root',
})
export class EstabelecimentoService {
  private http = inject(HttpClient);
  private readonly apiUrl = `${environment.fullApiUrl}/v1/estabelecimentos`;

  /** GET /api/v1/estabelecimentos — envelope { success, data }. */
  listar(): Observable<EstabelecimentoResponse[]> {
    return this.http
      .get<{ success: boolean; data: EstabelecimentoResponse[] }>(this.apiUrl)
      .pipe(map((r) => r.data ?? []));
  }
}
